const useCalendarExport = (currentDate, monthNames, language, sendNotification) => {
  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) return resolve();
      const s = document.createElement("script");
      s.src = src;
      s.onload = () => resolve();
      s.onerror = (e) => reject(e);
      document.head.appendChild(s);
    });

  const createCalendarCanvas = async () => {
    const el = document.getElementById("calendar-export");
    if (!el) throw new Error("Calendar element not found");
    if (typeof window.html2canvas === "undefined") {
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js"
      );
    }

    const clone = el.cloneNode(true);
    clone.style.display = "block";
    clone.style.position = "absolute";
    clone.style.left = "-9999px";
    clone.style.width = `${el.offsetWidth || 900}px`;

    const minimalTextColor = document.createElement("style");
    minimalTextColor.innerHTML = `
      #calendar-export, #calendar-export * {
        color: #111 !important;
        -webkit-text-fill-color: #111 !important;
      }
    `;
    clone.insertBefore(minimalTextColor, clone.firstChild);
    document.body.appendChild(clone);

    const scale = Math.max(2, window.devicePixelRatio || 2);
    const canvas = await window.html2canvas(clone, {
      scale,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    clone.remove();
    return canvas;
  };

  const exportCalendar = async (asPdf = false) => {
    try {
      const canvas = await createCalendarCanvas();
      if (!asPdf) {
        const imgData = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = imgData;
        const fileName = `Calendar-${monthNames[currentDate.getMonth()]}-${currentDate.getFullYear()}.png`;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return;
      }

      if (typeof window.jspdf === "undefined") {
        await loadScript(
          "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"
        );
      }

      let jsPDFConstructor = null;
      if (window.jspdf && window.jspdf.jsPDF) jsPDFConstructor = window.jspdf.jsPDF;
      else if (window.jsPDF) jsPDFConstructor = window.jsPDF;
      else if (window.jspdf) jsPDFConstructor = window.jspdf;
      if (!jsPDFConstructor) throw new Error("jsPDF not available");

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDFConstructor("p", "pt", "a4");
      const pageWidth = 595.28;
      const pageHeight = 841.89;
      const margin = 20;

      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let remainingHeight = imgHeight;
      while (remainingHeight > 0) {
        pdf.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);
        remainingHeight -= pageHeight - margin * 2;
        if (remainingHeight > 0) pdf.addPage();
      }

      const fileName = `Calendar-${monthNames[currentDate.getMonth()]}-${currentDate.getFullYear()}.pdf`;
      pdf.save(fileName);
    } catch (err) {
      console.error("Export failed", err);
      sendNotification({
        title: language === "ar" ? "خطأ" : "Error",
        message:
          language === "ar"
            ? "فشل في إنشاء الصيغة المطلوبة. حاول مرة أخرى أو استخدام ميزة الطباعة."
            : "Failed to generate export. Try again or use Print to save as PDF.",
        type: "error",
      });
    }
  };

  return { exportCalendar, createCalendarCanvas };
};

export default useCalendarExport;
